<template>
    <div class="container">
        <el-form label-width="100px" size="mini" class="form">
            <el-row type="flex">
                <el-form-item label="视频日期：" style="margin-bottom: 0;">
                    <el-date-picker
                        v-model="date"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-button plain size="mini" style="margin-left: 10px;" @click="search">搜索</el-button>
                <div style="margin-left: auto;">
                    <el-button type="warning" size="mini" v-href="'/guandan/deckVideoDetail'">+添加记录</el-button>
                </div>
            </el-row>
        </el-form>
        <el-row style="height:calc(100% - 80px)">
            <el-table
                stripe
                style="width: 100%"
                height="100%"
                v-loading="loading"
                element-loading-text="数据加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                :data="list"
                size="mini"
            >
                <el-table-column label="预览" align="center" width="150px">
                    <template slot-scope="scope">
                        <div class="preview_video" @click="preview(scope.row)">
                            <img :src="scope.row.CoverUrl"/>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="LeagueName" label="赛事" align="center" min-width="160px"></el-table-column>
                <el-table-column prop="LeagueGroupName" label="组别" align="center" min-width="80px"></el-table-column>
                <el-table-column label="轮次" align="center" min-width="60px">
                    <template slot-scope="scope">
                        第{{scope.row.RoundsNo}}轮
                    </template>
                </el-table-column>
                <el-table-column label="桌号" align="center" min-width="60px">
                    <template slot-scope="scope">
                        {{scope.row.TableNo}}号桌
                    </template>
                </el-table-column>
                <el-table-column label="运动员姓名" align="center" min-width="140px">
                     <template slot-scope="scope">
                        <el-row type="flex" justify="center" style="text-align: left;">
                            <span style="margin-right: 15px;">
                                <div>东：{{scope.row.PlayerNames.PlayerEastName}}</div>
                                <div style="margin-top: 10px;">西：{{scope.row.PlayerNames.PlayerWestName}}</div>
                            </span>
                            <span>
                                <div>南：{{scope.row.PlayerNames.PlayerSouthName}}</div>
                                <div style="margin-top: 10px;">北：{{scope.row.PlayerNames.PlayerNorthName}}</div>
                            </span>
                        </el-row>
                    </template>
                </el-table-column>
                <el-table-column label="视频日期" align="center" width="100px">
                    <template slot-scope="scope">
                        {{dateFormat(scope.row.VideoTime)}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" min-width="100px">
                    <template slot-scope="scope">
                        <el-button type="text" @click="alterRow(scope.row)">修改</el-button>
                        <el-button type="text" @click="deleteRow(scope.row.ReplayVideoId)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <DeckVideoDetail :visible.sync="deckVideoDetailVisible" :data="deckVideoDetailData" @success="deckVideoDetailSuccess"></DeckVideoDetail>
        <PreviewVideo :visible.sync="previewVideoVisible" :data="previewVideoData"></PreviewVideo>
    </div>
</template>
<script>
import utils from '@/utils';
import DeckVideoDetail from './components/DeckVideoDetail.vue';
import PreviewVideo from './components/PreviewVideo.vue';
export default {
    name: 'deckVideoList',
    components: {
        DeckVideoDetail,
        PreviewVideo
    },
    data(){
        return {
            date: [],
            list: [],
            loading: false,
            deckVideoDetailData: null,
            deckVideoDetailVisible: false,
            previewVideoData: null,
            previewVideoVisible: false
        }
    },
    created() {
        let EndTime = Date.now(),
            BeginTime = Date.now() - (7 * 24 * 60 * 60 * 1000);
        this.date = [utils.dateFormat(BeginTime, 'yyyy-MM-dd'), utils.dateFormat(EndTime, 'yyyy-MM-dd')];
        this.getDataList();
    },
    methods: {
        dateFormat(value){
            return utils.dateFormat(value, 'yyyy-MM-dd');
        },
        getDataList(){
            this.loading = true;
            this.$api.GetReplayVideoEditList({
                "BeginTime": utils.dateFormat(this.date[0], 'yyyy-MM-ddT00:00:00'),
                "EndTime": utils.dateFormat(this.date[1], 'yyyy-MM-ddT23:59:59')
            }).then(data=>{
                this.loading = false;
                if(data.Code == 0){
                    this.list = data.ReplayVideoList;
                }
            }).catch(()=>{
                this.loading = false;
            })
        },
        search(){
            this.getDataList();
        },
        preview(item){
            this.previewVideoData = {
                src: item.VideoUrl,
                poster: item.CoverUrl
            };
            this.previewVideoVisible = true;
        },
        alterRow(data){
            this.deckVideoDetailData = data;
            this.deckVideoDetailVisible = true;
        },
        deckVideoDetailSuccess(){
            this.getDataList();
        },
        deleteRow(id){
            this.$confirm('确定要删除此条记录吗？', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.DeleteReplayVideo({
                    "ReplayVideoId": id
                }).then(data=>{
                    if(data.Code == 0){
                        this.$message.success('删除成功');
                        this.getDataList();
                    }
                })
            })
        }
    }
}
</script>
<style scoped>
    .preview_video{
        position: relative;
        cursor: pointer;
    }
    .preview_video::after{
        content: '';
        width: 36px;
        height: 36px;
        background: url('~@/assets/imgs/video_play.png') no-repeat center / 100%;
        position: absolute;
        top: calc(50% - 18px);
        left: calc(50% - 18px);
    }
    .preview_video img{
        width: 130px;
        height: 73px;
        border-radius: 10px;
        object-fit: cover;
    }
</style>